const session_expired = {
    title: 'セッションの有効期限が切れました',
    subtitle: 'セッションの有効期限が切れ、切断されました。以下のボタンをクリックして再度管理コンソールにサインインしてください。',
    button: '再度サインイン',
};
export default Object.freeze(session_expired);
